export default {
    methods: {
        validateTimetracking(rule, value, callback){
            if (value == null && this.ruleForm.service == 0) {
                callback();
            } else if (value != null && this.ruleForm.service == 0 || value == null && this.ruleForm.service > 0) {
                callback(new Error(this.$l10n.__('Les 2 champs doivent être remplis')));
            } else {
                callback();
            }
        },
        validateService(rule, value, callback) {
            if (value == 0 && this.ruleForm.timetrackingTime == null) {
                callback();
            } else if (value > 0 && this.ruleForm.timetrackingTime == null || value == 0 && this.ruleForm.service != null) {
                callback(new Error(this.$l10n.__('Les 2 champs doivent être remplis')));
            } else {
                callback();
            }
        }
    }
}